import * as Yup from 'yup';

export const TokenSchema = Yup.object().shape({
  codigoSolicitud: Yup.number().required('codigoSolicitud es requerido'),

  correoElectronicoInvitado: Yup.string()
    .email('Debe ser un correo electrónico válido')
    .required('correoElectronicoInvitado es requerido'),

  correoElectronico: Yup.string()
    .email('Debe ser un correo electrónico válido')
    .required('correoElectronico es requerido')
});
